import Box from "@material-ui/core/Box";
import DnsIcon from "@material-ui/icons/Dns";
import WarningIcon from "@material-ui/icons/Warning";
import * as Sentry from "@sentry/browser";
import React, { useCallback, useState } from "react";
import { useAlert } from "react-alert";

import { makeRequest } from "../../../util";
import EmptyState from "../../Components/EmptyState";
import QueryEditor from "../../Components/QueryEditor";
import QueryResultTable from "../../Components/QueryResultTable";
import { DEFAULT_STRINGS } from "../../utils/constants/common";

// We want to hide columns used internally by airbyte
function isDisplayableColumn(columnName) {
  return !columnName.startsWith("_airbyte");
}

/**
 * Playground for SQL
 * Wrapper Container
 * we can have Other Feature Components added to this
 * */
const Playground = ({ disabledMessage }) => {
  const alert = useAlert();
  const [queryResults, setQueryResults] = useState();
  const [isLoading, setIsLoading] = useState(false);
  /**
   * handles running the query selected by user and returns data for the query
   * and updating store/context if required */
  const handleOnQueryRun = useCallback(
    (query) => {
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      makeRequest("run_sql_query_directly", { query })
        .then((response) => {
          if (response.data.error_message) {
            return;
          }
          const { columns, results } = response.data;
          const metaData = {
            columns: columns.filter(isDisplayableColumn).map((column) => ({
              name: column,
            })),
          };
          setQueryResults({ metaData, rows: results });
        })
        .catch((e) => {
          alert.error("Something went wrong. Unable to run SQL query.");
          console.log(e);
          Sentry.captureException(e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [isLoading, alert]
  );

  return (
    <Box display="flex" height="100%" width="100%" flexDirection="column">
      <QueryEditor
        isLoading={isLoading}
        onRunQuery={handleOnQueryRun}
        disabled={!!disabledMessage}
      />
      {disabledMessage ? (
        <EmptyState
          icon={<WarningIcon fontSize="large" />}
          title="Contact Support"
          subtitle={disabledMessage}
        />
      ) : !queryResults ? (
        <EmptyState
          icon={<DnsIcon fontSize="large" />}
          title={DEFAULT_STRINGS.WELCOME_MESSAGE_TITLE}
          subtitle={DEFAULT_STRINGS.WELCOME_MESSAGE_SUBTITLE}
        />
      ) : (
        <QueryResultTable tableData={queryResults} />
      )}
    </Box>
  );
};

export default Playground;
